import Angular from 'angular';
import Loader from 'angular-ecmascript/module-loader';

// Core
import ViewService from '../core/views/view.service';
import ModalDelegate from '../core/views/modal-delegate.service';
import LoadingIndicator from '../core/components/loading-indicator/loading-indicator';
import Duration from '../core/components/duration/duration';
import TextModal from "../core/components/test-modal/text.modal";
import LoadingInterceptor from '../core/interceptors/loading.interceptor';
import TextareaAutoheight from '../core/directives/textarea-autoheight';
import DisableScrollOnSwipe from '../core/directives/disable-scroll-on-swipe';
import ConvertTo from '../core/directives/convert-to';
import IfScreenSize from '../core/directives/if-screen-size';
import ColorFilter from "../core/filters/color.filter";

// Configuration
import MainConfig from './main.config';
import RoutesConfig from './routes.config';
import LocaleConfig from './locale.config';
import HttpConfig from './http.config';
import CacheConfig from './cache.config';

// Interceptors
import TimeoutConfigInterceptor  from './interceptors/timeoutConfig.interceptor';
import AuthenticationInterceptor  from './interceptors/authentication.interceptor';

// Views
import LoginView from './views/login/login';
import BranchSelectionView from './views/branch-selection/branch-selection';
import DashboardView from './views/dashboard/dashboard';
import BookingsView from './views/bookings/bookings';
import BookingDetailsView from './views/booking-details/booking-details';
import ScanTagView from './views/scantag/scantag';
import VehicleDetailsView from './views/vehicle-details/vehicle-details';
import NewBookingServiceView from './views/new-booking-service/new-booking-service';
import NewBookingDurationView from './views/new-booking-duration/new-booking-duration';
import NewBookingResourceView from './views/new-booking-resource/new-booking-resource';
import NewBookingDateView from './views/new-booking-date/new-booking-date';
import NewBookingTimeView from './views/new-booking-time/new-booking-time';
import NewBookingOptionsView from './views/new-booking-options/new-booking-options';
import SearchView from './views/search/search';
import SettingsView from './views/settings/settings';

export const Name = 'module.main';

let MainModule = Angular.module(Name, [
    // Core
    ViewService.name,
    ModalDelegate.name,
    LoadingIndicator.name,
    Duration.name,
    TextModal.name,
    LoadingInterceptor.name,
    TextareaAutoheight.name,
    DisableScrollOnSwipe.name,
    ConvertTo.name,
    IfScreenSize.name,
    ColorFilter.name,

    // Interceptors
    TimeoutConfigInterceptor.name,
    AuthenticationInterceptor.name,

    // Views
    LoginView.name,
    BranchSelectionView.name,
    DashboardView.name,
    BookingsView.name,
    BookingDetailsView.name,
    ScanTagView.name,
    VehicleDetailsView.name,
    NewBookingServiceView.name,
    NewBookingDurationView.name,
    NewBookingResourceView.name,
    NewBookingDateView.name,
    NewBookingTimeView.name,
    NewBookingOptionsView.name,
    SearchView.name,
    SettingsView.name
]);

new Loader(MainModule)
    .load(MainConfig)
    .load(RoutesConfig)
    .load(LocaleConfig)
    .load(HttpConfig)
    .load(CacheConfig);

export default MainModule;



// WEBPACK FOOTER //
// ./src/modules/main/module.js